import { exp } from "@tensorflow/tfjs";
import api from "./api"

export const getsubdivisionsBasedonDid= async(district)=>{
    try{
        const response = await api.get(`/api/subdivisions/district/${district}`);
         return response.data;
    }
    catch(error){
        console.log(error)
    }

}

export const getBlocksBasedOnsubId=async(subDivisionId)=>{
    try{
        const response = await api.get(`/api/blocks/subdivision/${subDivisionId}`);
        return response.data;
    }catch(error){
        console.error("error",error)
    }
}
export const saveGodownLocation = async (payload) => {
  try {
    const response = await api.post("/api/locations", payload);
    return response.data;
  } catch (error) {
    console.error("Error saving godown location:", error);
    throw error;
  }
};


export const getGodownListByBlockId=async(blockId)=>{
    try{
        const response = await api.get(`/api/locations/block/${blockId}`);
        return response.data;
    }catch(error){
        console.error("error",error)
    }
}


export const updatetheGodowns=async(godownId,payload)=>{
    try{
        const response= await api.patch(`/api/locations/update-location/${godownId}`, payload);
    }
    catch(error){
        console.log('Lat long update fail',error);
    }

}
// Add this to your monthlyAttendanceService.js file

export const getLocationHierarchyReport = async (stateId, districtId, godownType) => {
    try {
        let url = `/api/locations/hierarchyreport?stateId=${stateId}`;
        
        if (districtId) {
            url += `&districtId=${districtId}`;
        }
        
        if (godownType) {
            url += `&godownType=${godownType}`;
        }

        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching location hierarchy report:", error);
        throw error;
    }
};


export const getBlockList=async(districtId, subDivisionId)=>{
    try{
        const response = await api.get(`api/blocks/district/${districtId}?subDivisionId=${subDivisionId}`);
        return response.data;
    }catch(error){
        console.error("error",error)
    }
}
export const saveBlock= async (payload) => {
  try {
    const response = await api.post("/api/blocks", payload);
    return response.data;
  } catch (error) {
    console.error("Error saving godown location:", error);
    throw error;
  }
};

export const updateBlockService= async (id,payload) => {
  try {
    const response = await api.put(`/api/blocks/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error saving godown location:", error);
    throw error;
  }
};

export const saveSubDivision= async (payload) => {
  try {
    const response = await api.post("/api/subdivisions", payload);
    return response.data;
  } catch (error) {
    console.error("Error saving godown location:", error);
    throw error;
  }
};
// Update SubDivision
export const updateSubDivisionService = async (id, payload) => {
  try {
    const response = await api.put(`/api/subdivisions/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating subdivision:", error);
    throw error;
  }
};


export const getSubDivisionsByDistrictId = async (districtId) => {
  try {
    const response = await api.get(`/api/subdivisions/district/${districtId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subdivisions:", error);
    throw error;
  }
};

export const updateSubDivision = async (id, payload) => {
  try {
    const response = await api.put(`/api/subdivisions/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating subdivision:", error);
    throw error;
  }
};
